var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "he-row",
    { staticClass: "row-reception ml-0 px-3" },
    [
      _c(
        "he-column",
        [
          _c(
            "he-row",
            [
              _c(
                "he-column",
                [
                  _c("text-output", {
                    staticClass: "text-center",
                    attrs: {
                      label: "Type Transformateur :",
                      defaultValue: _vm.type
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: _vm.getPrefixedName("type")
                    },
                    domProps: { value: _vm.type }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "he-column",
                [
                  _c("text-output", {
                    staticClass: "text-center",
                    attrs: { label: "Puissance :", defaultValue: _vm.puissance }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: _vm.getPrefixedName("puissance")
                    },
                    domProps: { value: _vm.puissance }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "he-column",
                [
                  _c("text-output", {
                    staticClass: "text-center",
                    attrs: {
                      label: "TPC :",
                      defaultValue: _vm.tpc ? "Oui" : "Non"
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: { type: "hidden", name: _vm.getPrefixedName("tpc") },
                    domProps: { value: _vm.tpc }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "he-row",
            [
              _c(
                "he-column",
                [
                  _c("text-output", {
                    staticClass: "text-center",
                    attrs: {
                      label: "Numéro poste ENEDIS :",
                      defaultValue: _vm.numPoste
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: _vm.getPrefixedName("numPoste")
                    },
                    domProps: { value: _vm.numPoste }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "he-column",
                [
                  _c("text-output", {
                    staticClass: "text-center",
                    attrs: {
                      label: "Nom poste ENEDIS :",
                      defaultValue: _vm.nomPoste
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: _vm.getPrefixedName("nomPoste")
                    },
                    domProps: { value: _vm.nomPoste }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "he-row",
            [
              _c(
                "he-column",
                [
                  _c("file-list", {
                    ref: "files",
                    attrs: { label: "Bon de commande" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "he-row",
            [
              _c(
                "he-column",
                [
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: _vm.getPrefixedName("gestionTransfoId")
                    },
                    domProps: { value: _vm.gestionTransfoId }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: _vm.getPrefixedName("itemIndex")
                    },
                    domProps: { value: _vm.index }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    ref: "done",
                    attrs: { type: "hidden", name: _vm.getPrefixedName("done") }
                  }),
                  _vm._v(" "),
                  _c("text-input", {
                    attrs: {
                      name: _vm.getPrefixedName("marque"),
                      label: "Marque :",
                      defaultValue: _vm.marque,
                      required: true,
                      readonly: _vm.internalReadOnly
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "he-column",
                [
                  _c("text-input", {
                    attrs: {
                      name: _vm.getPrefixedName("numeroSerie"),
                      label: "Numéro de Série :",
                      defaultValue: _vm.numeroSerie,
                      required: true,
                      readonly: _vm.internalReadOnly
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "he-column",
                [
                  _c("text-input", {
                    attrs: {
                      name: _vm.getPrefixedName("numGestionEntreprise"),
                      label: "Numéro de gestion interne entreprise :",
                      defaultValue: _vm.numGestionEntreprise,
                      readonly: _vm.internalReadOnly
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "he-row",
            [
              _c(
                "he-column",
                [
                  _c("text-input", {
                    attrs: {
                      name: _vm.getPrefixedName("anneeFabrication"),
                      label: "Année de fabrication :",
                      defaultValue: _vm.anneeFabrication,
                      required: true,
                      readonly: _vm.internalReadOnly
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "he-column",
                [
                  _c("datepicker-date", {
                    attrs: {
                      name: _vm.getPrefixedName("dateLivraison"),
                      label: "Date de livraison :",
                      defaultValue: _vm.dateLivraison,
                      required: true,
                      readonly: _vm.internalReadOnly
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("he-column", [
                _c("div", { staticClass: "form-group row" }, [
                  _c(
                    "label",
                    { staticClass: "col-12 col-form-label text-left" },
                    [_vm._v("Bon de commande transformateur :")]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.bonCommandeIdNeuf,
                          expression: "bonCommandeIdNeuf"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        name: _vm.getPrefixedName("bonCommandeIdNeuf"),
                        readonly: _vm.internalReadOnly === true,
                        required: ""
                      },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.bonCommandeIdNeuf = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _vm.bcTransfos.length > 1
                        ? _c("option", { domProps: { value: null } }, [
                            _vm._v(" — ")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.bcTransfos, function(t) {
                        return _c(
                          "option",
                          { key: t.value, domProps: { value: t.value } },
                          [_vm._v(_vm._s(t.text))]
                        )
                      })
                    ],
                    2
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "he-row",
            [
              _c(
                "he-column",
                [
                  _c("number-input", {
                    ref: "mtotale",
                    attrs: {
                      name: _vm.getPrefixedName("masseTotale"),
                      label: "Masse Totale (en Kg) :",
                      defaultValue: _vm.masseTotale,
                      required: true,
                      readonly: _vm.internalReadOnly
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "he-column",
                [
                  _c("number-input", {
                    ref: "mdielec",
                    attrs: {
                      name: _vm.getPrefixedName("masseDielectrique"),
                      label: "Masse Diélectrique (en Kg)",
                      defaultValue: _vm.masseDielectrique,
                      required: true,
                      readonly: _vm.internalReadOnly
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "he-column",
                [
                  _c("number-input", {
                    ref: "msolide",
                    attrs: {
                      name: _vm.getPrefixedName("masseSolide"),
                      label: "Masse Solide (en Kg) (calcul automatique) :",
                      readonly: "true",
                      defaultValue: _vm.masseSolide,
                      required: true
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.bonCommandeIdNeuf != null
            ? _c(
                "he-row",
                [
                  _c(
                    "he-column",
                    [
                      _c("upload-file", {
                        attrs: {
                          "file-list-type": "2647",
                          status: "0",
                          name: _vm.getPrefixedName("bonLivraison"),
                          defaultValue: _vm.bonLivraison,
                          label: "Bon de livraison du transformateur :",
                          required: true,
                          "bc-transfo-id": _vm.bonCommandeIdNeuf,
                          readonly: _vm.internalReadOnly
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "he-row",
            [
              _c(
                "he-column",
                [
                  _c("text-multiline", {
                    attrs: {
                      name: _vm.getPrefixedName("commentaire"),
                      label: "Commentaire :",
                      defaultValue: _vm.commentaire,
                      readonly: _vm.internalReadOnly
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.internalReadOnly
            ? _c(
                "he-row",
                [
                  _c("he-column", { staticClass: "text-center pb-4 pr-0" }, [
                    _c("div", { staticClass: "d-inline-block mx-auto" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "d-inline-block mx-auto action-button btn btn-primary",
                          attrs: {
                            type: "button",
                            formaction: "/Workflow/ValidActionTransfo",
                            value: "2",
                            "data-index-item": _vm.index,
                            "data-mandatory-fields-scope": ".row-reception",
                            "data-action-transfo": "6",
                            "data-bc-transfo-id": _vm.bonCommandeIdNeuf
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-save" }),
                          _vm._v(
                            "\n                        Enregistrer les données de ce transformateur\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "message d-inline-block" })
                    ])
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-174a482c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-174a482c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/Workflow/Components/SpecificComponents/ReceptionTransformateur.vue
// module id = 587
// module chunks = 0